module.exports = __webpack_public_path__ + "media/images/countrysquared/hm-5865fccf7084d7f6e96817b406625b1c.svg";